import React from 'react'

interface MarginLeftRightIconProps {
  stroke?: string
}

export const MarginLeftRightIcon = ({
  stroke = 'var(--color-iconTertiary)',
}: MarginLeftRightIconProps) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83398 6.5L5.83398 13.5C5.83398 14.9001 5.83398 15.6002 5.98536 16.135C6.11852 16.6054 6.33099 16.9878 6.59233 17.2275C6.88943 17.5 7.27836 17.5 8.05621 17.5L11.9451 17.5C12.7229 17.5 13.1119 17.5 13.409 17.2275C13.6703 16.9878 13.8828 16.6054 14.0159 16.135C14.1673 15.6002 14.1673 14.9001 14.1673 13.5L14.1673 10L14.1673 6.5C14.1673 5.09987 14.1673 4.3998 14.0159 3.86502C13.8828 3.39462 13.6703 3.01217 13.409 2.77248C13.1119 2.5 12.7229 2.5 11.9451 2.5L8.05621 2.5C7.27836 2.5 6.88943 2.5 6.59233 2.77248C6.33099 3.01217 6.11852 3.39462 5.98536 3.86502C5.83398 4.3998 5.83398 5.09987 5.83398 6.5Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 5.41537L17.5 9.9987L17.5 14.582"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 5.41537L2.5 9.9987L2.5 14.582"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
